/* eslint-disable */
import type { Color } from "../../../ui/Color.pb";
import type { Image } from "../../../ui/Image.pb";

/**
 * Mooncake text styles.
 * See https://www.figma.com/file/Hgp77syia2RDcGhKI3QFMd/Mooncake-Core?node-id=1760%3A29.
 */
export enum TextStyle {
  BIG_MONEY = "BIG_MONEY",
  HEADER_1 = "HEADER_1",
  HEADER_2 = "HEADER_2",
  HEADER_3 = "HEADER_3",
  HEADER_4 = "HEADER_4",
  /** @deprecated */
  INPUT = "INPUT",
  MAIN_TITLE = "MAIN_TITLE",
  MAIN_BODY = "MAIN_BODY",
  SMALL_TITLE = "SMALL_TITLE",
  SMALL_BODY = "SMALL_BODY",
  STRONG_CAPTION = "STRONG_CAPTION",
  CAPTION = "CAPTION",
  IDENTIFIER = "IDENTIFIER",
}

export enum TextDecoration {
  STRIKETHROUGH = "STRIKETHROUGH",
  UNDERLINE = "UNDERLINE",
}

export enum HorizontalAlignment {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export interface Button {
  /**
   * Old usages of this proto may not have action_type set.
   * In this case, the assumption should be URL.
   */
  action_type?: ButtonButtonAction;
  /** client route */
  action_url?: string;
  half_sheet?: ShopInfoHalfSheet;
  background_color?: Color;
  text?: string | undefined;
  icon?:
    | Image
    | undefined;
  /** may be unset; use mooncake style instead of background_color */
  button_style?: ButtonButtonStyle;
  button_size?: ButtonButtonSize;
}

export enum ButtonButtonAction {
  DISMISS = "DISMISS",
  URL = "URL",
  HALF_SHEET = "HALF_SHEET",
}

/** Map to mooncake button style */
export enum ButtonButtonStyle {
  PRIMARY = "PRIMARY",
  SECONDARY = "SECONDARY",
  TERTIARY = "TERTIARY",
  OUTLINE = "OUTLINE",
}

export enum ButtonButtonSize {
  SMALL = "SMALL",
  LARGE = "LARGE",
}

export interface Avatar {
  /** initial_avatar can be provided at all time as a fallback */
  initials?: AvatarInitials;
  /** picture should be preferred over initials */
  picture?: Image;
  /** additional signal icon displayed at bottom right corner of the avatar */
  icon?: Image;
  /** client route when avatar is tapped */
  action_url?: string;
  /** apply white filter to colorize the avatar (similarily with activity and profiles) */
  colorize_avatar?: boolean;
  /** override avatar background color */
  background_color?: Color;
}

export interface AvatarInitials {
  initials?: string;
  text_color?: Color;
  background_color?: Color;
}

export interface Text {
  text?: string;
  text_style?: TextStyle;
  text_decoration?: TextDecoration;
  text_color?: Color;
  icon?: Image;
}

export interface Range {
  /** inclusive */
  start?: number;
  /** exclusive */
  end?: number;
}

export interface HighlightText {
  text?: string;
  /** If present guaranteed to be a valid range. */
  range?: Range;
  text_style?: TextStyle;
  text_color?: Color;
  highlighted_text_style?: TextStyle;
  highlighted_text_color?: Color;
  icon?: Image;
}

export interface Bullet {
  bullet_icon?: Image;
  bullet_title?: Text;
  bullet_body?: Text;
}

export interface ShopInfoHalfSheet {
  picture?: Image | undefined;
  avatar?:
    | Avatar
    | undefined;
  /**
   * Maximum pixel height for picture or avatar.
   * If null, then there is no max and the image should fill all horizontal space.
   */
  image_max_px_height?: number;
  image_horizontal_alignment?: HorizontalAlignment;
  title?: Text;
  subtitle?: Text;
  bullets?: Bullet[];
  action_button?: Button;
  footer?: Text;
  display_criteria?: ShopInfoHalfSheetDisplayCriteria;
}

export enum ShopInfoHalfSheetDisplayCriteria {
  /** ONCE_PER_SECTION - show shop info only once for any of the items in the section. */
  ONCE_PER_SECTION = "ONCE_PER_SECTION",
  /** ALWAYS - show shop info every time user taps on the item. */
  ALWAYS = "ALWAYS",
  /** NEVER - The sheet should never be shown on shop hub. Instead, it should be passed to an associated view where it will be presented there. */
  NEVER = "NEVER",
}
